import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';



export default function AppConfirmModal({ open, setOpen, title, description, buttonTitle }) {
    const handleClose = (todo) => {
        setOpen(false, todo);
    };
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={() => handleClose(false)}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {description}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={() => handleClose(false)}>
                    {t("Cancel")}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleClose(true)}
                    sx={{
                        color: "#F8FAFF",
                        textTransform: "capitalize",
                        borderRadius: "8px",
                        ":disabled": { backgroundColor: "#0088F5", opacity: 0.4 },
                    }}
                >
                    {buttonTitle}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

AppConfirmModal.propTypes = {
    open: PropTypes.bool,
    setOpen: PropTypes.func,
    title: PropTypes.string,
    description: PropTypes.string,
    buttonTitle: PropTypes.string,
}